/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Perm_FinancialsInputs */

const en_team_perm_financials = /** @type {(inputs: Team_Perm_FinancialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Financials`)
};

const es_team_perm_financials = /** @type {(inputs: Team_Perm_FinancialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finanzas`)
};

const fr_team_perm_financials = /** @type {(inputs: Team_Perm_FinancialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finances`)
};

const de_team_perm_financials = /** @type {(inputs: Team_Perm_FinancialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finanzen`)
};

const id_team_perm_financials = /** @type {(inputs: Team_Perm_FinancialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keuangan`)
};

/** @type {(inputs: Team_Perm_FinancialsInputs) => LocalizedString} */
const ja_team_perm_financials = en_team_perm_financials;

/** @type {(inputs: Team_Perm_FinancialsInputs) => LocalizedString} */
const zh_team_perm_financials = en_team_perm_financials;

/** @type {(inputs: Team_Perm_FinancialsInputs) => LocalizedString} */
const ar_team_perm_financials = en_team_perm_financials;

/** @type {(inputs: Team_Perm_FinancialsInputs) => LocalizedString} */
const it_team_perm_financials = en_team_perm_financials;

/** @type {(inputs: Team_Perm_FinancialsInputs) => LocalizedString} */
const ru_team_perm_financials = en_team_perm_financials;

/** @type {(inputs: Team_Perm_FinancialsInputs) => LocalizedString} */
const pt_team_perm_financials = en_team_perm_financials;

/** @type {(inputs: Team_Perm_FinancialsInputs) => LocalizedString} */
const ko_team_perm_financials = en_team_perm_financials;

/**
* | output |
* | --- |
* | "Financials" |
*
* @param {Team_Perm_FinancialsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_perm_financials = /** @type {((inputs?: Team_Perm_FinancialsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Perm_FinancialsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_perm_financials(inputs)
	if (locale === "es") return es_team_perm_financials(inputs)
	if (locale === "fr") return fr_team_perm_financials(inputs)
	if (locale === "de") return de_team_perm_financials(inputs)
	if (locale === "ja") return ja_team_perm_financials(inputs)
	if (locale === "zh") return zh_team_perm_financials(inputs)
	if (locale === "ar") return ar_team_perm_financials(inputs)
	if (locale === "id") return id_team_perm_financials(inputs)
	if (locale === "it") return it_team_perm_financials(inputs)
	if (locale === "ru") return ru_team_perm_financials(inputs)
	if (locale === "pt") return pt_team_perm_financials(inputs)
	return ko_team_perm_financials(inputs)
});